import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  CompanyCropData,
  AttachCropResponse,
  CropParams,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

export const getCropsByCompanyID = async (
  companyId: string
): Promise<ApiResponse<CompanyCropData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<CompanyCropData[]>>(
      `${API_URLS.COMPANY.GET_CROPS_BY_ID}/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching crops by company ID:", error);
    throw error;
  }
};

export const attachCrop = async (
  params: CropParams
): Promise<ApiResponse<AttachCropResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<AttachCropResponse>>(
      API_URLS.COMPANY.ATTACH_CROP,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error attaching crop:", error);
    throw error;
  }
};

export const detachCrop = async (
  company_crop_id: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.COMPANY.DETACH_CROP,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { company_crop_id },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error detaching crop:", error);
    throw error;
  }
};
